import { atom } from 'nanostores'

export function createProductsStore<T>(initial: T | null = null) {
  return atom<T | null>(initial)
}

export function createBooleanStore(initial: boolean) {
  return atom(initial)
}
